import { render, staticRenderFns } from "./Tank.vue?vue&type=template&id=353711f7&"
import script from "./Tank.vue?vue&type=script&lang=js&"
export * from "./Tank.vue?vue&type=script&lang=js&"
import style0 from "./Tank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports